var _g, _path, _g2, _path2, _g3, _g4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleBackExtensionMiddleOffsetBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 165,
    viewBox: "0 0 125 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4838_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 38.7998L70.5 10.7998V68.7998L15.5 96.7998L15.5 38.7998Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.5 38.7998L70.5 10.7998V68.7998L15.5 96.7998L15.5 38.7998Z",
    fill: "#A0A0A0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4838_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2 59.5L90.2 31.5V92.5L35.2 120.5L35.2 59.5Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M35.2 59.5L90.2 31.5V92.5L35.2 120.5L35.2 59.5Z",
    fill: "#EC691A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4838_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.2 120.5L90.2 92.5V89.5L35.2 117.5V120.5Z",
    fill: "#EC691A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7223 124.639C41.9175 124.834 42.2341 124.834 42.4294 124.639L45.6113 121.457C45.8066 121.262 45.8066 120.945 45.6113 120.75C45.4161 120.555 45.0995 120.555 44.9042 120.75L42.0758 123.578L39.2474 120.75C39.0521 120.555 38.7355 120.555 38.5403 120.75C38.345 120.945 38.345 121.262 38.5403 121.457L41.7223 124.639ZM42.0758 113.758H41.5758V124.285H42.0758H42.5758V113.758H42.0758Z",
    fill: "#EC691A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.0866,
    y1: 117.288,
    x2: 90.6482,
    y2: 89.0364,
    stroke: "#EC691A",
    strokeWidth: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3482_6294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 92L109 64V122L54 150L54 92Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54 92L109 64V122L54 150L54 92Z",
    fill: "#EC691A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9863 152.845L53.9863 83.0041L109 54.1523L109 124.808",
    stroke: "#EC691A",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3 54.5C84.3 54.2239 84.0762 54 83.8 54C83.5239 54 83.3 54.2239 83.3 54.5H84.3ZM83.4465 64.8536C83.6418 65.0488 83.9583 65.0488 84.1536 64.8536L87.3356 61.6716C87.5308 61.4763 87.5308 61.1597 87.3356 60.9645C87.1403 60.7692 86.8237 60.7692 86.6285 60.9645L83.8 63.7929L80.9716 60.9645C80.7764 60.7692 80.4598 60.7692 80.2645 60.9645C80.0693 61.1597 80.0693 61.4763 80.2645 61.6716L83.4465 64.8536ZM83.3 54.5V64.5H84.3V54.5H83.3Z",
    fill: "#EC691A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3885 105.385L15.5 115.897L35.3885 137.618L54.4766 140.098M86.9674 127.807C85.7567 135.618 85.6107 136.19 84.4 144L61.8427 141.036",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.46 140.103L61.8679 141.036",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 144C84.2 137.869 84.3315 135.611 84.3315 129.48M15.5 115.897V38.8512M35.3885 137.618V61.5M90.0001 33L84.3759 67.8019L35.3885 61.5M90.0001 33L70.4696 11M90.0001 33L109.5 55M90.0001 33V65.6997M35.3885 61.5L15.5 38.8512M35.3885 61.5L54.5001 83.5M70.4696 11L15.5 38.8512M70.4696 11L70.5 43.0542",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.5 43V88",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90 65.5V107",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.3007 67.9004C84.3007 67.9004 84.3313 106.517 84.3313 129.48",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.9674 127.807C88.002 120.672 88.9654 114.089 90 106.954L70.4695 88L35.2291 105.486",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4838_4816",
    x: 0.5,
    y: 0.799805,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4838_4816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4838_4816",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4838_4816",
    x: 20.2,
    y: 21.5,
    width: 85,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4838_4816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4838_4816",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4838_4816",
    x: 39.5,
    y: 45.5,
    width: 85,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4838_4816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4838_4816",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4838_4816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 57,
    fill: "white",
    transform: "translate(35.2 68.2998)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4838_4816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 57,
    fill: "white",
    transform: "translate(54.5 92.2998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleBackExtensionMiddleOffsetBack);
export default __webpack_public_path__ + "static/media/MiddleBackExtensionMiddleOffsetBack.29acf5452ce37f557306032f6abaefdc.svg";
export { ForwardRef as ReactComponent };